export const ENT_TEXT_CONSTANTS = {
  THANK_YOU: "Thank you for your interest in registering for Entrainment 25.",
  SYSTEM_WAITING_LIST:
    "Currently, all the seats are booked. If you still want to register, please proceed and we will keep you in our waiting list series and keep you updated when seats become available.",
  USER_WAITING_LIST:
    "Due to overwhelming demand, we are unable to confirm your seat now. We will revert back to you if the seats become available.",
  PROCEED_TO_PAYMENT: "Please proceed to the payment page.",
  PAYMENT_ACKNOWLEDGEMENT_ONLINE:
    "Your registration for Entrainment 25 is confirmed.",
  PAYMENT_ACKNOWLEDGEMENT_OFFLINE:
    "We acknowledge your provisional registration for Entrainment 25.",
  INVOICE_DOWNLOAD: "Click here to download 'Tax invoice'",
  PROCEED_TO_TRAVEL: "Please update your travel plan and other details.",
  PAYMENT_PENDING: "Your payment for Entrainment 2025 is pending.",
  OFFLINE_NOTE: "Note: Cheques are subject to realization",
  CANCELLED_TEXT: "Your registration has been cancelled.",
  WAITLIST_LINK_RELEASED: "Your registration has been successfully considered.",
  DENIED_TEXT:
    "In spite of our best efforts, we are unable to confirm your seat.",
  DOWNLOAD_FAILED: "Invoice download failed. Please contact your RM.",
  REG_OPENED: "OPENED",
  REG_NOT_OPENED: "NOT_OPENED",
  REG_CLOSED: "CLOSED",
  REG_CLOSED_TEXT:
    "Due to an overwhelming response, registrations for Entrainment 25 are closed.",
  REFRESH_SUCCESS: "Registrations status refreshed successfully.",
  REGISTRATION_STATUS_UPDATED:
    "Please note, there is an update on your registration.",
  REG_CLOSED_TEXT_AT_ACTION: "Registrations for Entrainment 25 are closed.",
  SEAT_TRANSFERRED_TEXT: "This seat is transferred.",
  ERROR_ALL_FIELDS_REQUIRED: "all fields are required."
};
